import { AjaxDispatcher, ActionCreator } from './ajax-dispatcher';
import {
    getUrlWithoutQueryString,
    QueryParameter,
    buildQueryParameters
} from './common';


export interface FilterQueryParameter {
    getFilterQueryParameters(): QueryParameter[];
}

export default class SearchFilter implements FilterQueryParameter {
    private componentList: Element;
    private componentListName: string;
    private searchFilter: HTMLFormElement;
    private onSubmit: () => void;
    private queryParams: QueryParameter[];


    constructor(componentList: Element, onSubmit: () => void = null, queryParams: QueryParameter[] = []) {
        this.componentList = componentList;
        this.componentListName = componentList.getAttribute('data-component');
        this.searchFilter = this.componentList.querySelector('form[data-component="SearchFilter"]');
        this.onSubmit = onSubmit;
        this.queryParams = queryParams;
        this.searchFilter.addEventListener('submit', (event) => this.filter(event));
    }

    getFilterQueryParameters(): QueryParameter[] {
        return [
            { key: 'filter-value', value: this.getFilterValue() }
        ];
    }

    private getQueryParameters(): QueryParameter[] {
        return [
            ...this.queryParams,
            { key: 'filter-value', value: this.getFilterValue() }
        ];
    }

    private filter(event: Event): void {
        event.preventDefault();
        const queryParameters = this.getQueryParameters();
        this.refreshUrl(queryParameters);

        const action = new ActionCreator().reloadComponent(this.componentListName);
        action.successAction = this.onSubmit;

        new AjaxDispatcher().dispatchGetAction(action);
    }

    private getFilterValue(): string {
        const inputElement = <HTMLInputElement>(
            document.querySelector('input[data-search]')
        );

        return inputElement ? inputElement.value : null;
    }

    private refreshUrl(queryParameters: QueryParameter[]): void {
        const queryString = buildQueryParameters(queryParameters);
        const url = queryString
            ? getUrlWithoutQueryString() + '?' + queryString
            : getUrlWithoutQueryString();

        const newUrlState = { title: document.title, url: url };
        window.history.pushState(newUrlState, document.title, url);
    }
}
